import { Link } from 'react-router-dom';

const SOCIALS = [
  { icon: 'ri-weibo-fill', label: '微博' },
  { icon: 'ri-twitter-x-line', label: 'X' },
  { icon: 'ri-instagram-line', label: 'Instagram' },
  { icon: 'ri-youtube-line', label: 'YouTube' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg">优</span>
              <span className="font-heading text-lg text-foreground-950">小仓优子 · 演员资料库</span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed">
              一个专注于小仓优子个人资料、影视作品与最新动态的资料站，为影迷与行业人士提供清晰、详实的查阅体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">
              <Link to="/about" className="hover:text-accent-600 transition-colors cursor-pointer">站点导航</Link>
            </h4>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-4 text-sm">
              <li><Link to="/" className="text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/works" className="text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">影视作品</Link></li>
              <li><Link to="/category/news" className="text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">新闻动态</Link></li>
              <li><Link to="/profile" className="text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">演员简介</Link></li>
              <li><Link to="/about" className="text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer">关于网站</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950 mb-4">关注她</h4>
            <div className="flex items-center gap-3">
              {SOCIALS.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="w-10 h-10 rounded-full bg-background-50 border border-secondary-300 flex items-center justify-center text-primary-600 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
            <p className="text-xs text-foreground-500 mt-4 leading-relaxed">
              本站为演示站点，图文内容均为虚构示例，仅用于展示用途。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 小仓优子资料库 · 演示站点 · 保留所有权利</p>
          <p className="text-xs text-foreground-500">内容仅供参考，与任何真实人物或机构无关</p>
        </div>
      </div>
    </footer>
  );
}